// extracted by mini-css-extract-plugin
export default {"h1":"_2kvAwvoAh_msCoDEpivj7M","headline":"_3r7-XZJn4JScGZK3ikj24Q","display":"_1UedC1sH6tf7fp5zOQa5zN","inset":"_1gDcepiLPwP5HQVnrkB25o"};